import React from "react";
import styled from "styled-components";
import womanDoctor from "../../SVGs/womanDoctor.svg";
import { NavLink } from "react-router-dom";
import RequireLogout from "../../permissions.js/RequireLogout";
import Nav from "../Common/Nav";
import Footer from "../Common/Footer";

function Home() {
  return (
    <>
      <Nav />
      <Container>
        <InnerContainer>
          <FadingBlueContainer>
          <LeftContaienr>
            <Title>Welcome to Hippocratic Portal</Title>
            <Text>
              Your gateway to personalized financial solutions and seamless
              management of your financial matters.
            </Text>
            <CustomNavLink to={"/Login"}>
              <Button>Signin</Button>
            </CustomNavLink>
          </LeftContaienr>

          </FadingBlueContainer>

        </InnerContainer>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 95vh;
`;
const FadingBlueContainer = styled.div`
display:flex;
align-items:center;
  padding: 100px 30px;
  height: 95vh;
  width: 90vw;
  border-radius: 30px;
background: linear-gradient(
  to right, 
  var(--darkBlue) 0%, 
  var(--darkBlue) 10%,
  transparent 80%
);
  @media screen and (max-width: 700px) {
    width: 90vw;
  padding: 100px 20px;
background: linear-gradient(
  to right, 
  var(--darkBlue) 0%, 
  var(--darkBlue) 10%,
  transparent 130%
);
    // background-position: right -60vw bottom 0px;
  }
`;
const InnerContainer = styled.div`

  height: 95vh;
  width: 90vw;
  border-radius: 30px;

  background-image: url(${womanDoctor});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: local;

  @media screen and (max-width: 700px) {
    // background-position: right -60vw bottom 0px;
  }
`;

const LeftContaienr = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
gap:5vh;
  min-height: 50vh;
  width: 50vw;

  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: column;
    width: 70vw;
  }
`;

const Title = styled.p`
  color: var(--white);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%; /* 49.5px */
  letter-spacing: -1.1px;

  @media screen and (max-width: 700px) {
    font-size: 40px;
  }
`;

const Text = styled.p`
  color: var(--white);
  font-family: "Museo Sans Cyrl";
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
  line-height: 28px; /* 116.667% */

  @media screen and (max-width: 700px) {
    font-size: 20px;
  }
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 129px;
  height: 40px;

  border-radius: 20px;

  cursor: pointer;
  background-color:var(--white); ;

  color: var(--darkBlue);
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
    @media screen and (max-width: 700px) {
  }
`;

const CustomNavLink = styled(NavLink)`
  text-decoration: none;
`;
export default RequireLogout(Home);
